import { ColumnDef } from "@tanstack/react-table";
import { Stack } from "@/core/components/ui/stack";
import { Typography } from "@/core/components/ui/typography";
import { dayjs } from "@/core/utils/date";
import { formatDate, sortDateDescending } from "@/core/utils/date";

interface WithEventDate {
  event_date: string;
}

const EventDateCol = <T extends WithEventDate>(): ColumnDef<T> => ({
  header: "Event date",
  accessorFn: (row) => row.event_date,
  enableSorting: true,
  sortingFn: (rowA, rowB) =>
    sortDateDescending(rowA.original.event_date, rowB.original.event_date),
  sortDescFirst: true,
  cell: ({ row }) => {
    const date = row.original.event_date;
    return (
      <Stack gap="xs">
        <Typography variant="bodyW1">{formatDate(date)}</Typography>
        <Typography variant="captionW1" textColor="tertiary">
          {dayjs(date).format("h:mm A")}
        </Typography>
      </Stack>
    );
  },
});

export default EventDateCol;
